/** Look-up › Quality › Batch No. Finder (a packaging utility, user 2026-10-28). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { BatchFinderPage } from "@/features/packaging/components/utilities-page";

export const Route = createFileRoute("/_app/quality/batch-finder/")({
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.batch_finder")) throw redirect({ to: "/" });
  },
  component: BatchFinderPage,
});
